import { Box, Modal } from '@iheartjane/reefer';

import { Authentication } from './authentication';
import type { AuthenticationProps } from './authentication';

export interface LoginModalProps extends Omit<AuthenticationProps, 'onClose'> {
  /** Function called when the modal is closed (overlay, X, or any Cancel button). */
  onRequestClose(): void;

  /** Boolean for whether the modal is open. */
  open: boolean;
}

export const LoginModal = ({
  open,
  onRequestClose,
  ...authenticationProps
}: LoginModalProps) => {
  return (
    <Modal
      ariaLabelledBy="auth-screen-label"
      data-testid="log-in-modal"
      onRequestClose={onRequestClose}
      open={open}
      overlayClose
      variant="dialogue"
    >
      <Modal.Content>
        <Box maxWidth="297px">
          <Authentication {...authenticationProps} onClose={onRequestClose} />
        </Box>
      </Modal.Content>
    </Modal>
  );
};
